import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { httpPost, httpUrl } from '../api/httpClient';
import errorIcon from '../img/common/error.png';
import mainlogo from '../img/common/mainlogo.png';
import '../styles/main.scss';

export default function ParentLogin() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const params = useParams();

    const [phone, setPhone] = useState('');
    const [name, setName] = useState('');
    const [loginError, setLoginError] = useState(false);
    const [orderNumber, setOrderNumber] = useState('');

    // URL에서 orderNumber 가져오기
    useEffect(() => {
        console.log('[ParentLogin] ===== useEffect 실행 =====');
        console.log('[ParentLogin] 현재 전체 URL:', window.location.href);
        console.log('[ParentLogin] searchParams 전체:', Object.fromEntries(searchParams.entries()));
        console.log('[ParentLogin] URL params:', params);

        // 1. URL 경로 파라미터에서 orderNumber 확인 (/cash/:orderNumber)
        const orderNumberFromPath = params.orderNumber;
        // 2. 쿼리 파라미터에서 orderNumber 확인 (?orderNumber=xxx)
        const orderNumberFromQuery = searchParams.get('orderNumber');

        const finalOrderNumber = orderNumberFromPath || orderNumberFromQuery;

        console.log('[ParentLogin] orderNumberFromPath:', orderNumberFromPath);
        console.log('[ParentLogin] orderNumberFromQuery:', orderNumberFromQuery);
        console.log('[ParentLogin] finalOrderNumber:', finalOrderNumber);

        if (finalOrderNumber) {
            setOrderNumber(finalOrderNumber);
            console.log('[ParentLogin] ✅ URL에서 orderNumber 확인:', finalOrderNumber);
        } else {
            console.warn('[ParentLogin] ❌ URL에 orderNumber가 없습니다.');
            console.warn('[ParentLogin] URL 파라미터 확인 필요!');
        }
    }, [searchParams, params]);

    const handleBack = () => {
        navigate('/');
    };

    const handleLogin = async () => {
        console.log('[ParentLogin] ===== handleLogin 함수 시작 =====');
        console.log('[ParentLogin] 현재 state 값:', { phone, name, orderNumber });

        const trimmedPhone = (phone || '').trim();
        const trimmedName = (name || '').trim();

        console.log('[ParentLogin] trim 후 값:', { trimmedPhone, trimmedName });

        // 입력값 검증
        if (!trimmedPhone || !trimmedName) {
            console.log('[ParentLogin] ❌ 입력값 검증 실패');
            alert('회원 연락처와 이름을 모두 입력해주세요.');
            setLoginError(true);
            return;
        }

        console.log('[ParentLogin] ✅ 입력값 검증 통과');

        // orderNumber 검증
        if (!orderNumber) {
            console.log('[ParentLogin] ❌ orderNumber 없음');
            alert('주문 정보를 찾을 수 없습니다.\n올바른 URL을 통해 접속해주세요.');
            return;
        }

        console.log('[ParentLogin] ✅ orderNumber 검증 통과');

        try {
            console.log('[ParentLogin] 🚀 API 호출 직전');
            console.log('[ParentLogin] httpUrl.verifyParent:', httpUrl.verifyParent);
            console.log('[ParentLogin] 인증 요청 데이터:', {
                orderNumber,
                name: trimmedName,
                phone: trimmedPhone
            });

            const result = await httpPost(httpUrl.verifyParent, [], {
                orderNumber: orderNumber,
                name: trimmedName,
                phone: trimmedPhone,
            });

            console.log('[ParentLogin] ✅ API 호출 완료');
            console.log('[ParentLogin] 인증 응답:', result);

            if (result?.code === 100) {
                // 인증 성공
                console.log('[ParentLogin] ✅ 인증 성공');
                console.log('[ParentLogin] 인증 응답 데이터:', result);

                // accessToken과 orderNumber 추출
                const accessToken = result?.result?.accessToken;
                const orderNumber = result?.result?.orderInfo?.orderNumber;

                console.log('[ParentLogin] accessToken:', accessToken);
                console.log('[ParentLogin] orderNumber:', orderNumber);

                if (!accessToken || !orderNumber) {
                    console.error('[ParentLogin] ❌ 필수 데이터 누락:', { accessToken, orderNumber });
                    alert('인증 정보를 가져오는데 실패했습니다.');
                    return;
                }

                // ✅ accessToken을 localStorage에 저장 (쿠폰 API 호출 시 사용)
                localStorage.setItem('accessToken', accessToken);
                console.log('[ParentLogin] 💾 accessToken localStorage에 저장 완료');

                // 인증 성공 후 바로 결제 페이지로 이동
                // CheckPaymentToss에서 /user/payment/draft/order 호출
                const targetUrl = `/cash?orderNumber=${encodeURIComponent(orderNumber)}&parentToken=${encodeURIComponent(accessToken)}`;
                console.log('[ParentLogin] 결제 페이지로 이동:', targetUrl);

                alert('인증이 완료되었습니다.\n결제를 진행해주세요.');

                setTimeout(() => {
                    console.log('[ParentLogin] navigate 실행:', targetUrl);
                    navigate(targetUrl);
                }, 100);
            } else {
                // 인증 실패
                console.log('[ParentLogin] ❌ 인증 실패:', result);
                const errorMessage = result?.message || '회원 정보를 확인해주세요.';
                alert(errorMessage);
                setLoginError(true);
            }
        } catch (e) {
            console.error('[ParentLogin] ❌ 인증 오류 (catch):', e);
            console.error('[ParentLogin] 오류 상세:', {
                message: e.message,
                stack: e.stack,
                response: e.response
            });
            alert('인증 중 오류가 발생했습니다.\n잠시 후 다시 시도해주세요.');
            setLoginError(true);
        }

        console.log('[ParentLogin] ===== handleLogin 함수 종료 =====');
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleLogin();
        }
    };

    return (
        <div className="parent-login-container">
            <div className="top-bar">
                <button className="back-button"
                // onClick={handleBack}
                >
                    {/* <img src={backarrow} alt="뒤로가기" className="icon-24" /> */}
                </button>
            </div>

            <div className="login-content">
                <div className="logo-section">
                    <img src={mainlogo} alt="스카이써니 로고" className="main-logo" />
                </div>

                <div className="title-wrapper">
                    <div className="title-line"></div>
                    <h1 className="page-title">스카스카 캐시충전</h1>
                    <div className="title-line"></div>
                </div>

                <div className="input-section">
                    <div className="input-group">
                        <div className={`input-wrapper ${loginError ? 'error' : ''}`}>
                            <label className="input-label">연락처</label>
                            <input
                                type="tel"
                                placeholder="연락처를 입력하세요"
                                value={phone}
                                onChange={(e) => {
                                    setPhone(e.target.value);
                                    setLoginError(false);
                                }}
                                onKeyPress={handleKeyPress}
                                className="login-input"
                                autoCapitalize="none"
                            />
                        </div>
                    </div>

                    <div className="input-group">
                        <div className={`input-wrapper ${loginError ? 'error' : ''}`}>
                            <label className="input-label">이름</label>
                            <input
                                type="text"
                                placeholder="이름을 입력하세요"
                                value={name}
                                onChange={(e) => {
                                    setName(e.target.value);
                                    setLoginError(false);
                                }}
                                onKeyPress={handleKeyPress}
                                className="login-input"
                            />
                        </div>
                    </div>

                    {loginError && (
                        <div className="error-message">
                            <img src={errorIcon} alt="에러" className="icon-16" />
                            <span>회원 정보를 확인해주세요.</span>
                        </div>
                    )}
                </div>

                <button className="login-button" onClick={handleLogin}>
                    인증하기
                </button>
            </div>

            <style jsx>{`
                .parent-login-container {
                    min-height: 100vh;
                    min-height: 100dvh; /* 동적 viewport height - 네비게이션바 고려 */
                    background-color: #ffffff;
                    display: flex;
                    flex-direction: column;
                    padding-bottom: env(safe-area-inset-bottom, 0px); /* iOS Safe Area */
                }

                .top-bar {
                    padding: 16px;
                    display: flex;
                    align-items: center;
                }

                .back-button {
                    background: none;
                    border: none;
                    padding: 8px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .icon-24 {
                    width: 24px;
                    height: 24px;
                }

                .icon-16 {
                    width: 16px;
                    height: 16px;
                    margin-right: 4px;
                }

                .login-content {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding: 0 20px;
                    padding-bottom: max(50px, calc(50px + env(safe-area-inset-bottom, 0px)));
                    overflow-y: auto; /* 스크롤 가능하도록 */
                }

                .logo-section {
                    padding: 60px 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .main-logo {
                    width: 150px;
                    height: auto;
                    object-fit: contain;
                }

                .title-wrapper {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    max-width: 390px;
                    margin: 20px 0 30px;
                    gap: 16px;
                }

                .title-line {
                    flex: 1;
                    height: 1px;
                    background-color: #e0e0e0;
                }

                .page-title {
                    font-size: 18px;
                    font-weight: 700;
                    color: #000000;
                    white-space: nowrap;
                    text-align: center;
                    margin: 0;
                }

                .input-section {
                    width: 100%;
                    max-width: 390px;
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                }

                .input-group {
                    display: flex;
                    flex-direction: column;
                }

                .input-wrapper {
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    border: 1px solid #e5e5e5;
                    border-radius: 8px;
                    background-color: #ffffff;
                    padding: 12px 16px 8px;
                    transition: all 0.2s;
                }

                .input-wrapper:focus-within {
                    border-color: #2f3032;
                    background-color: #ffffff;
                }

                .input-label {
                    font-size: 12px;
                    font-weight: 500;
                    color: #666666;
                    margin-bottom: 4px;
                }

                .login-input {
                    width: 100%;
                    border: none;
                    background: transparent;
                    font-size: 14px;
                    font-weight: 400;
                    color: #000000;
                    outline: none;
                    padding: 0;
                }

                .login-input::placeholder {
                    color: #c0c0c0;
                }

                .input-wrapper.error {
                    border-color: red;
                }

                .error-message {
                    display: flex;
                    align-items: center;
                    color: red;
                    font-size: 12px;
                    margin-top: -10px;
                }

                .login-button {
                    width: 100%;
                    max-width: 390px;
                    height: 52px;
                    background-color: #2f3032;
                    color: #ffffff;
                    border: none;
                    border-radius: 8px;
                    font-size: 16px;
                    font-weight: 500;
                    cursor: pointer;
                    transition: background-color 0.2s;
                    margin-top: 30px;
                    margin-bottom: 20px; /* 하단 여백 추가 */
                    flex-shrink: 0; /* 버튼이 축소되지 않도록 */
                    /* 터치 영역 확보 */
                    touch-action: manipulation;
                    -webkit-tap-highlight-color: transparent;
                }

                .login-button:hover {
                    background-color: #1a1b1c;
                }

                .login-button:active {
                    background-color: #000000;
                }
                
                /* 안드로이드 네비게이션바 대응 */
                @supports (padding-bottom: env(safe-area-inset-bottom)) {
                    .login-button {
                        margin-bottom: max(20px, env(safe-area-inset-bottom));
                    }
                }
            `}</style>
        </div>
    );
}

